module.exports = "build/assets/mobileLeftPapers.e0809ba4.png";